<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { Currency } from "@core/schema/Currency.js";
	import type { Locale } from "@core/schema/Locale.js";
	import { formatPrice } from "@core/utils/formatPrice.js";

	interface Props {
		withTax: number;
		withoutTax: number;
		taxRate: number;
		currency: Currency;
		locale: Locale;
		withoutTaxLabel: string;
	}

	const { withTax, withoutTax, taxRate, currency, locale, withoutTaxLabel }: Props = $props();
</script>

<div class="flex items-start flex-col xl:flex-row xl:items-end gap-x-2 gap-y-1 mt-2 lg:mt-0">
	<span class="font-antipol font-medium text-6 lg:text-10 leading-tighter">
		{#if currency === Currency.CZK}
			<Formatted text={formatPrice(Math.ceil(withTax), currency, locale, false)} />
		{:else}
			<Formatted text={formatPrice(withTax, currency, locale, true)} />
		{/if}
	</span>
	<span class="text-fcrgray text-3 xl:text-4 leading-normal xl:mb-1">
		{#if taxRate !== 0}
			<Formatted text={formatPrice(withoutTax, currency, locale, true)} />
		{/if}
		<Formatted text={withoutTaxLabel} />
	</span>
</div>
